import { Component, inject, OnDestroy } from '@angular/core';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { takeWhile } from 'rxjs/operators';
import { PlanwertDetailComponent } from '../planwert-detail/planwert-detail.component';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'redispatch-planwert-page',
    templateUrl: './planwert-page.component.html',
    styleUrls: [
        './planwert-page.component.scss',
    ],
    standalone: false,
})
export class PlanwertPageComponent implements OnDestroy {

    private componentDestroyed = false;

    private activateRoute = inject(ActivatedRoute);
    private westnetzSidenavService = inject(WestnetzSidenavService);

    constructor() {

        this.activateRoute.queryParams
            .pipe(takeWhile(() => !this.componentDestroyed))
            .subscribe(params => {
                if (params && params.erzeugungsanlage) {
                    this.westnetzSidenavService.openRightnav(PlanwertDetailComponent);
                }
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed = true;
    }

}
